/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from 'classnames';
import { useGetUser } from 'src/hooks';
import { CommonPlanCardContent } from 'src/pages/PaymentBetaPage/components/CommonPlanCardContent';
import { PlanSectionType, SubscriptionPlanInfo, UserTier } from 'src/types';
import { convertTierName } from 'src/utils/user';
import { AVAILABLE_FEATURES_LIST } from 'src/constants';
import { PlanCardContent } from 'src/pages/PaymentBetaPage/components/PlanCardContent';
import { PlanKind } from 'src/types/wallet/models/PlanKind';
import { useMemo } from 'react';

interface CancelSubscriptionDifferentPlanItemProps {
  item: UserTier;
  plans: SubscriptionPlanInfo[] | undefined;
}

export const CancelSubscriptionDifferentPlanItem = ({
  item,
  plans,
}: CancelSubscriptionDifferentPlanItemProps) => {
  const { tier_id, isTeamsTier } = useGetUser();

  const isNewPlanPage = AVAILABLE_FEATURES_LIST.newSuperNinjaPlans;

  const getOriginalPriceLabel = (
    currentPlan: SubscriptionPlanInfo | undefined,
  ) => {
    const price = isTeamsTier
      ? currentPlan?.per_seat?.original_price
      : currentPlan?.original_price;

    if (!price) {
      return '-';
    }

    return roundAmount(price);
  };

  const roundAmount = (value?: number) => {
    if (value !== 0 && !value) {
      return value;
    }
    return Math.round(value / 100);
  };

  const getDiscountedPriceLabel = (
    currentPlan: SubscriptionPlanInfo | undefined,
  ) => {
    const price = isTeamsTier
      ? currentPlan?.per_seat?.total_recurring_amount
      : currentPlan?.discounted_price;

    if (!price) {
      return '-';
    }
    return roundAmount(price);
  };

  const differentPlanType: PlanSectionType = useMemo(() => {
    if (item === UserTier.STANDARD) {
      return 'Standard';
    }

    if (item === UserTier.PRO) {
      return 'Pro';
    }

    if (item === UserTier.ULTRA) {
      return 'Ultra';
    }

    if (item === UserTier.SUPERNINJA_ULTRA) {
      return 'SuperNinja_Ultra';
    }
    return 'SuperNinja_Ultra';
  }, [item]);

  const isStandardType = item === UserTier.STANDARD;
  const isProType = item === UserTier.PRO;
  const isUltraType = item === UserTier.ULTRA;

  const currentPlan = plans?.find(
    ({ plan_id }) =>
      plan_id ===
      (`${
        isNewPlanPage ? item.replace('_', '-') : item
      }-monthly` as unknown as PlanKind),
  );
  const currentPlanDiscountedPrice = currentPlan?.discounted_price;
  const originalPriceLabel = getOriginalPriceLabel(currentPlan);
  const discountPriceLabel = getDiscountedPriceLabel(currentPlan);

  return (
    <div
      className={classNames('nj-plan-section nj-plan-section--cancel-flow', {
        'nj-plan-section--teams': isTeamsTier,
      })}
    >
      <div className={classNames('nj-upgrade-form')}>
        <div
          className={classNames({
            'nj-upgrade-form--team-header': isTeamsTier,
            'nj-upgrade-form--individual-header': !isTeamsTier,
          })}
        >
          <div className="nj-plan-section--current-plan">
            <div className="nj-plan-section--header-wrapper">
              <h5 className="nj-plan-section--title-wrapper">
                <span className="nj-plan-section--plan-name-alt">
                  {isTeamsTier
                    ? 'Business '
                    : tier_id
                      ? convertTierName(item)
                      : ''}
                </span>
              </h5>

              <p className="nj-plan-section--current-plan-price">
                {currentPlanDiscountedPrice !== 0 && (
                  <span className="nj-plan-section--current-plan-sale-price">
                    <s>${originalPriceLabel}</s>
                    &nbsp;
                  </span>
                )}
                <span className="nj-plan-section--current-plan-sale-price">
                  $
                  {currentPlanDiscountedPrice !== 0
                    ? discountPriceLabel
                    : originalPriceLabel}
                  &nbsp;
                </span>
                <span className="nj-plan-section--current-plan-sale-description">
                  {isTeamsTier ? 'per seat/month' : '/month'}
                </span>
              </p>

              {isNewPlanPage ? (
                <br />
              ) : (
                <span className="nj-plan-section--current-plan-description colored">
                  Unlimited tasks
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/*TODO: WIP* /}
      {/* <PlanCardContent isTeams={isTeamsTier} type={differentPlanType} /> */}
    </div>
  );
};
